import React from "react";
import { ButtonBase, Grid, makeStyles, Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import * as COLORS from "@material-ui/core/colors";

const useStyles = makeStyles((theme) => ({
  button: {
    width: "100%",
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    "&:hover, &$focusVisible": {
      backgroundColor: COLORS.green[900],
      color: COLORS.blue[100],
      
    },
  },
  coinName: {
    opacity: 0.6,
    
  },
  coinImage: {
    width: 30, // Adjust the image width as needed
    height: 30, // Adjust the image height as needed
    marginRight: theme.spacing(3), // Adjust the margin as needed
  },
}));

CoinButton.propTypes = {
  coinName: PropTypes.string.isRequired,
  coinAbbr: PropTypes.string.isRequired,
  imageURI: PropTypes.string, // Define imageURI as a prop
  onClick: PropTypes.func.isRequired,
};

export default function CoinButton(props) {
  const { coinName, coinAbbr, imageURI, onClick, ...other } = props;
  const classes = useStyles();

  return (
    <ButtonBase focusRipple className={classes.button} onClick={onClick}>
      <Grid container alignItems="center">
        {imageURI && (
          <Grid item>
            <img src={imageURI} alt={`${coinName} Logo`} className={classes.coinImage} />
          </Grid>
        )}
        <Grid item style={{ textAlign: "left" }}>
          <Typography variant="h6">{coinAbbr}</Typography>
          <Typography variant="body2" className={classes.coinName}>
            {coinName}
          </Typography>
        </Grid>
      </Grid>
    </ButtonBase>
  );
}
